import { Injectable, NgZone } from '@angular/core';
import { Client, IMessage, Message, Stomp } from '@stomp/stompjs';
import { Observable, Subject } from 'rxjs';
import SockJS from 'sockjs-client';
import { environment } from '../../environments/environment';
import { ToastrService } from 'ngx-toastr';
@Injectable({
  providedIn: 'root',
})
export class NotificationWebsocketService {
  private client: Client;
  private notificationSubject = new Subject<any>();
  private visitUpdateSubject = new Subject<any>();
  private todaysVisitsUpdateSubject = new Subject<any>();
  private systemEventSubject = new Subject<any>();
  private username: string = '';
  private socketUrl = environment.serverUrl + 'ws';

  constructor(
    private toastr: ToastrService,
    private ngZone: NgZone // ensures toast runs inside Angular zone
  ) {
    console.log('Initializing WebSocket client with URL:', this.socketUrl);
    this.client = new Client({
      webSocketFactory: () => new SockJS(this.socketUrl),
      debug: (str) => {},
      reconnectDelay: 5000,
    });
    console.log('WebSocket client initialized:', this.client);
    // 🔹 Handle browser online/offline
  window.addEventListener('offline', () => {
    this.ngZone.run(() => this.toastr.error('Could not perform the request!'));
  });

  window.addEventListener('online', () => {
    this.ngZone.run(() => this.toastr.success('Internet reconnected!'));
  });
  }

  connect(username: string) {
  // ✅ Disconnect existing connection before starting a new one
  if (this.client && this.client.active) {
    this.client.deactivate();
  }
  this.username = username;

  this.client.onConnect = () => {
    console.log('WebSocket connected successfully');

    // Subscribe to user-specific notifications
    this.client.subscribe(
      `/topic/notifications/${this.username}`,
      (message: IMessage) => {
        console.log('Received notification:', message.body);
        try {
          const payload = JSON.parse(message.body);
          if (
            payload?.type === 'ROLE_CHANGED' ||
            payload?.type === 'PERMISSION_CHANGED'
          ) {
            this.systemEventSubject.next(payload);
          } else {
            this.notificationSubject.next(payload);
          }
        } catch (e) {
          console.error('Failed to parse notification:', message.body, e);
        }
      },
    );

    // Subscribe to visit updates
    this.client.subscribe(`/topic/visit-updates`, (message: IMessage) => {
      try {
        const payload = JSON.parse(message.body);
        this.visitUpdateSubject.next(payload);
      } catch (e) {
        console.error('Failed to parse visit update:', message.body, e);
      }
    });
    //Subscribe to today's visits updates
      this.client.subscribe(`/topic/todays-visits-update`, (message: IMessage) => {
        try {
          const payload = JSON.parse(message.body);
          this.todaysVisitsUpdateSubject.next(payload);
          console.log('Received todays visits update:', payload);
        } catch (e) {
          console.error('Failed to parse todays visits update:', message.body, e);
        }
      });
  };

  this.client.onStompError = (frame) => {
    console.error('Broker error:', frame.headers['message']);
    console.error('Details:', frame.body);
  };

  this.client.activate();
}


  // connectWEB() {
  //   this.client.onConnect = () => {
  //     this.client.subscribe(`/topic/visit-updates`, (message: IMessage) => {
  //       try {
  //         const payload = JSON.parse(message.body);
  //         this.visitUpdateSubject.next(payload); // emit the visit update
  //       } catch (e) {
  //         console.error('Failed to parse notification:', message.body, e);
  //       }
  //     });
  //   };

  //   this.client.onStompError = (frame) => {
  //     console.error('Broker error:', frame.headers['message']);
  //     console.error('Details:', frame.body);
  //   };

  //   this.client.activate();
  // }

  getVisitUpdates(): Observable<any> {
    return this.visitUpdateSubject.asObservable();
  }

  getTodaysVisitsUpdates(): Observable<any> {
    return this.todaysVisitsUpdateSubject.asObservable();
  }

  disconnect() {
    if (this.client && this.client.active) {
      this.client.deactivate();
    }
  }

  getNotifications(): Observable<any> {
    return this.notificationSubject.asObservable();
  }

  getSystemEvents(): Observable<any> {
    return this.systemEventSubject.asObservable();
  }
}
